/**
 * Display helpers for account_psp_credentials (API JSON).
 */

export const formatIsoDateTime = (value) => {
    if (value === null || value === undefined || value === '') {
        return '';
    }
    try {
        return new Date(value).toLocaleString();
    } catch {
        return String(value);
    }
};

/**
 * @param {object} credential
 * @param {function} t i18n t function
 * @returns {string}
 */
export const credentialBatchSummaryText = (credential, t) => {
    if (!credential?.last_batch_check_at) {
        return t('accounts.credentials_batch_never');
    }
    const dateStr = formatIsoDateTime(credential.last_batch_check_at);
    if (credential.last_batch_check_ok === true) {
        return `${t('accounts.credentials_batch_ok')} (${dateStr})`;
    }
    if (credential.last_batch_check_ok === false) {
        return `${t('accounts.credentials_batch_failed')} (${dateStr})`;
    }
    return dateStr;
};

/**
 * @param {object} credential
 * @param {function} t
 * @returns {string}
 */
export const credentialOptionLabel = (credential, t) => {
    const parts = [credential.label || credential.id];
    const exp = formatIsoDateTime(credential.token_expires_at);
    if (exp) {
        parts.push(exp);
    }
    parts.push(credentialBatchSummaryText(credential, t));
    return parts.join(' — ');
};
